export default function cleanDeeplink(deeplink) {
    return deeplink
        .replace(/[0-9]{9}[0-9X]|[A-Z][A-Z0-9]{9}.*/, 'detail')
        .replace(/[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}/, 'detail')
        .replace(/(^\/|\/$)/g, '')
        .replace(/\//g, '-');
}
